var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!['/login'].includes(this.$route.path))?_c('MyHeader'):_vm._e(),_c('div',{staticClass:"content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }